module.exports = __webpack_public_path__ + "static/media/14UNEP13.a72c8f7b.jpg";